import { useState } from 'react';
import { createContainer } from 'unstated-next';

const initialState = {
  user: null,
  business: null,
  allPermissions: null,
  permissions: null,
  businessOptions: null,
  accessId: null,
  invited: false,
  redirectURL: null,
  paymentPlans: {
    month: [],
    year: [],
  },
};

export function useUserHook(stateParam) {
  const combinedState = {
    ...initialState,
    ...stateParam,
  };

  const [state, setState] = useState(combinedState);

  const setUser = user => {
    setState(prev => ({
      ...prev,
      user,
    }));
  };

  const resetUserState = () => {
    setState(prev => ({
      ...prev,
      user: null,
    }));
  };

  const setBusiness = business => {
    setState(prev => ({
      ...prev,
      business,
    }));
  };

  const setBusinessOptions = businessOptions => {
    setState(prev => ({
      ...prev,
      businessOptions,
    }));
  };

  const resetBusinessState = () => {
    setState(prev => ({
      ...prev,
      business: null,
      businessOptions: null,
    }));
  };

  const setPermissions = permissions => {
    setState(prev => ({
      ...prev,
      permissions,
    }));
  };

  const setAllPermissions = allPermissions => {
    setState(prev => ({
      ...prev,
      allPermissions,
    }));
  };

  const resetPermissions = () => {
    setState(prev => ({
      ...prev,
      permissions: null,
    }));
  };

  const setAccessId = accessId => {
    setState(prev => ({
      ...prev,
      accessId,
    }));
  };

  const setInvited = invited => {
    setState(prev => ({
      ...prev,
      invited,
    }));
  };

  const setRedirectURL = redirectURL => {
    setState(prevState => ({
      ...prevState,
      redirectURL,
    }));
  };

  const setPaymentPlans = plans => {
    setState(prev => ({
      ...prev,
      paymentPlans: plans,
    }));
  };

  return {
    state,
    setUser,
    resetUserState,
    setBusiness,
    setBusinessOptions,
    resetBusinessState,
    setPermissions,
    resetPermissions,
    setAccessId,
    setInvited,
    setAllPermissions,
    setRedirectURL,
    setPaymentPlans,
  };
}

const UserContainer = createContainer(useUserHook);

export default UserContainer;
